import { listen, isLoadMfeMessage, isData } from "@sinch/bus";
import { loadMFE } from "@sinch/mfe-loader";
import { useEffect } from "react";
import { remoteNameZod } from "../mfe/mfeConfig";

export const useLoadMfeHandler = () => {
  useEffect(() => {
    const unsub = listen((message) => {
      if (isData(message)) {
        const parsed = remoteNameZod.safeParse(message.payload.name);
        if (parsed.success) {
          loadMFE(parsed.data, message.payload.entry);
        } else {
          console.error(
            `${useLoadMfeHandler.name} failed to parse mfe name`,
            parsed.error
          );
        }
      }
    }, isLoadMfeMessage);

    return unsub;
  }, []);
};
